import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import ActionButton from '../../actionButton';
import InputField from '../../inputField';
import ToggleComponent from '../../toggleComponent';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing(6),
  },
  errorMessage: {
    position: 'absolute',
    bottom: -20,
  },
  dragButton: {
    position: 'relative',
    width: 22,
    height: 22,
    flexShrink: 0,
    marginRight: spacing(1.5),
    zIndex: 11,
    '& button': {
      width: 22,
      height: 22,
    },
  },
  dragIcon: {
    width: 8,
    height: 14,
  },
  dragTooltipLabel: {
    fontFamily: 'ProximaNova-Regular',
  },
  input: {
    width: 336,
  },
  actionButton: {
    flexShrink: 0,
    marginLeft: spacing(2),
  },
  actionIcon: {
    width: 18,
    height: 18,
  },
}));

const AdditionalRole = ({
  id,
  role,
  translations,
  dragRef = () => {},
  dragProps = null,
  hasError,
  errorMessage = '',
  onChangeName,
  onDelete,
  onUndoDelete,
}) => {
  const classes = useStyles();
  const handleChange = useCallback(
    e => onChangeName(e.target.value, id),
    [id, onChangeName]
  );

  const hasSavedId = Boolean(role?.id);
  const isMarkedForDeletion = Boolean(role?.shouldDelete);

  return (
    <div
      className={classes.root}
      ref={dragRef}
      {...(dragProps ? { ...dragProps.draggableProps } : {})}
    >
      <ActionButton
        className={classes.dragButton}
        iconClass={classes.dragIcon}
        tooltipLabelClass={classes.dragTooltipLabel}
        type={ACTION_BUTTON_TYPES.DRAG}
        tooltipText={translations?.dragTooltip}
        {...(dragProps ? { ...dragProps.dragHandleProps } : {})}
      />
      <InputField
        className={classes.input}
        customErrorClass={classes.errorMessage}
        placeholder={translations?.placeholder}
        value={role?.name || ''}
        error={hasError}
        errorMessage={errorMessage}
        onChange={handleChange}
        fullWidth
      />
      {hasSavedId ? (
        <ToggleComponent inKey={!isMarkedForDeletion}>
          {!isMarkedForDeletion ? (
            <ActionButton
              className={classes.actionButton}
              iconClass={classes.actionIcon}
              type={ACTION_BUTTON_TYPES.DELETE}
              tooltipText={translations?.deleteTooltip}
              onClickHandler={onDelete}
            />
          ) : (
            <ActionButton
              className={classes.actionButton}
              iconClass={classes.actionIcon}
              type={ACTION_BUTTON_TYPES.RELOAD}
              tooltipText={translations?.reloadTooltip}
              onClickHandler={onUndoDelete}
            />
          )}
        </ToggleComponent>
      ) : (
        <ActionButton
          className={classes.actionButton}
          iconClass={classes.actionIcon}
          type={ACTION_BUTTON_TYPES.DELETE}
          tooltipText={translations?.deleteTooltip}
          onClickHandler={onDelete}
        />
      )}
    </div>
  );
};

AdditionalRole.propTypes = {
  id: PropTypes.number.isRequired,
  role: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
  dragProps: PropTypes.object,
  errorMessage: PropTypes.string,
  hasError: PropTypes.bool.isRequired,
  dragRef: PropTypes.func,
  onChangeName: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onUndoDelete: PropTypes.func.isRequired,
};

export default AdditionalRole;
